import { Component, Inject, Input } from '@angular/core';
import { ApplicationFacade } from '@ridango/components';

import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-customer-account-user-avatar',
    templateUrl: './customer-account-user-avatar.component.html',
    styleUrls: ['./customer-account-user-avatar.component.scss']
})
export class CustomerAccountUserAvatarComponent {
    @Input() useMenuIconAvatar: boolean;

    assetsPath$ = this.applicationFacade.assetsPath$;

    constructor(
        @Inject('ENV') public env: Env,
        private applicationFacade: ApplicationFacade
    ) {}
}
